import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import Stack, { StackProps } from "@mui/material/Stack";
import { Option } from "~ui-components/components/atoms/option";

import range from "lodash/range";
import { MuiColorInput } from "mui-color-input";
import {
	LineSimpleConfigs,
	SymbolStyle,
} from "~ui-components/types/__generated/gql/graphql";

type Props = StackProps & {
	value: LineSimpleConfigs;
	onChange: (next: LineSimpleConfigs) => void;
};

export const LineStyle = (props: Props) => {
	const { value, onChange, ...stackProps } = props;
	const fill = value.symbolStyle?.fill ?? {};
	const stroke = value.symbolStyle?.stroke ?? {};

	const handleSymbolChange = <
		K extends keyof SymbolStyle,
		P extends keyof NonNullable<NonNullable<SymbolStyle[K]>>,
	>(
		section: K,
		prop: P,
		val: NonNullable<NonNullable<SymbolStyle[K]>[P]>,
	) => {
		const currentSymbolStyle = value.symbolStyle ?? {};
		const currentSection = (currentSymbolStyle[section] ?? {}) as Record<
			string,
			any
		>;

		onChange({
			...value,
			symbolStyle: {
				...currentSymbolStyle,
				[section]: {
					...currentSection,
					[prop]: val,
				},
			},
		});
	};

	return (
		<Stack
			spacing={3}
			{...stackProps}>
			<InputLabel>Line and Casing</InputLabel>
			<FormControl>
				<InputLabel>Line colour</InputLabel>
				<MuiColorInput
					sx={{ width: 200 }}
					format="hex"
					value={fill?.color ?? ""}
					onChange={(color) => handleSymbolChange("fill", "color", color)}
				/>
			</FormControl>
			<FormControl>
				<InputLabel>Line width</InputLabel>
				<OutlinedInput
					sx={{ width: 200 }}
					name="fill.width"
					onChange={(e) =>
						handleSymbolChange(
							"fill",
							"width",
							parseFloat(String(e.target.value)),
						)
					}
					// onBlur={handleBlur}
					value={fill?.width}
					type="number"
				/>
			</FormControl>
			<FormControl sx={{ width: 200 }}>
				<InputLabel>Line style</InputLabel>
				<Select
					name="fill.style"
					value={fill?.style}
					onChange={(e) =>
						handleSymbolChange(
							"fill",
							"style",
							e.target.value as "none" | "solid" | "dash" | "dot",
						)
					}>
					<Option value="none">None</Option>
					<Option value="solid">Solid</Option>
					<Option value="dash">Dash</Option>
					<Option value="dot">Dot</Option>
				</Select>
			</FormControl>
			<FormControl sx={{ width: 200 }}>
				<InputLabel>Line Opacity</InputLabel>
				<Select
					name="fill.opacity"
					value={fill?.opacity}
					type="number"
					onChange={(e) =>
						handleSymbolChange(
							"fill",
							"opacity",
							parseFloat(String(e.target.value)),
						)
					}>
					{range(0, 11).map((value) => (
						<Option
							key={value}
							value={value / 10}>
							{value * 10}%
						</Option>
					))}
				</Select>
			</FormControl>
			<FormControl sx={{ width: 200 }}>
				<InputLabel>Casing colour</InputLabel>
				<MuiColorInput
					sx={{ width: 200 }}
					format="hex"
					value={stroke?.color ?? ""}
					onChange={(color) => handleSymbolChange("stroke", "color", color)}
				/>
			</FormControl>

			<FormControl sx={{ width: 200 }}>
				<InputLabel>Casing width</InputLabel>
				<OutlinedInput
					sx={{ width: 200 }}
					name="stroke.width"
					onChange={(e) =>
						handleSymbolChange(
							"stroke",
							"width",
							parseFloat(String(e.target.value)),
						)
					}
					value={stroke?.width}
					type="number"
				/>
			</FormControl>

			<FormControl sx={{ width: 200 }}>
				<InputLabel>Casing opacity</InputLabel>
				<Select
					name="stroke.opacity"
					value={stroke?.opacity}
					type="number"
					onChange={(e) =>
						handleSymbolChange(
							"stroke",
							"opacity",
							parseFloat(String(e.target.value)),
						)
					}>
					{range(0, 11).map((value) => (
						<Option
							key={value}
							value={value / 10}>
							{value * 10}%
						</Option>
					))}
				</Select>
			</FormControl>
			<FormControl sx={{ width: 200 }}>
				<InputLabel>Casing style</InputLabel>
				<Select
					value={stroke.style ?? "solid"}
					onChange={(e) =>
						handleSymbolChange(
							"stroke",
							"style",
							e.target.value as "none" | "solid" | "dash" | "dot",
						)
					}>
					<Option value="none">None</Option>
					<Option value="solid">Solid</Option>
					<Option value="dash">Dash</Option>
					<Option value="dot">Dot</Option>
				</Select>
			</FormControl>
		</Stack>
	);
};
